export default __webpack_public_path__ + "static/media/DouglasLopes_06.90e65745.jpg";